import { apiRequest } from "../util/apiUtils";

export const quizList = async (params) => {
  try {
    const res = await apiRequest("get", `quiz/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const quizAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `quiz/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const quizDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `quiz/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const quizStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `quiz/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const quizDetails = async (payload) => {
  try {
    const res = await apiRequest("get", `quiz/details`, {
      queries: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const atemptQuiz = async (payload) => {
  try {
    const res = await apiRequest("post", `answer/submit-answer`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};
